export enum AnalyticsQueryKeysEnum {
  utm_source,
  utm_medium,
  utm_campaign,
  utm_content,
  utm_term,
  gclid,
  dclid,
  fbclid,
  irclickid,
}

export interface AnalyticsQueryKeys {
  analyticsQueryKeys: AnalyticsQueryKeys[];
}

export enum ContentTypesEnum {
  Campaigns = 'campaigns',
  Funds = 'funds',
  Settings = 'settings',
  OutageBanners = 'outage-banners',
}

export interface CheckoutStates {
  code: string;
  description: string;
  usaPhysicalState: boolean;
}

/**
 * Regions and their enumerated country codes
 */
export interface RegionsAndCountryCodes {
  region: string;
  countries: string[];
}
